<template>
  <Form @submit="$emit('submit', site)" :title="$t('meta.baseData')" bodyClass="">
    <FormInput :name="$t('sites.name')" v-model="site.name" required />
    <FormInput :name="$t('sites.description')" v-model="site.description" labelOptional />
    <div class="form-wrap">
      <span class="label">{{ $t('meta.project') }}</span>
      <ProjectSelect v-model="site.project_uuid" :companyUuid="companyUser.company_uuid" />
    </div>
    <SiteDrawHelp v-if="isNew" />
    <BaseMap
      :allowFourNewCoordinatesOnly="isNew"
      :editablePolygonFeature="geojsonFeature"
      :staticPolygons="staticPolygonsForMap"
      :childPolygons="areaPolygons"
      :fitBounds="siteBounds"
      :enableDraw="isNew"
      :zoomedOut="isNew"
      @coordinates-updated="handleCoordinatesUpdate"
      @coordinates-reset="resetCoordinates"
      enableGeocoder
    />
    <div class="form-wrap">
      <span class="label">{{ $t('meta.sitePlan') }} {{ `(${$t('meta.optional')})` }}</span>
      <ImageUpload v-model="site.image" :label="$t('imageUpload.add.site')" />
    </div>
    <Button type="submit" :disabled="submitDisabled">{{ $t(isNew ? 'sites.createSite' : 'sites.update') }}</Button>
  </Form>
</template>

<script>
import SiteDrawHelp from '@/views/companies/sites/SiteDrawHelp.vue'

import Button from '@/components/Button/index.vue'
import ImageUpload from '@/components/Form/ImageUpload.vue'
import FormInput from '@/components/Form/Input/index.vue'
import Form from '@/components/Form/index.vue'
import BaseMap from '@/components/Map/base.vue'
import ProjectSelect from '@/components/RouteEditor/ProjectSelect.vue'

import { staticPolygonsFromObject } from '@/utils/geojson'
import mapUtils from '@/utils/mapbox'

export default {
  inject: ['companyUser'],
  data() {
    return {
      site: this.initialSite || {
        image: {},
        company_uuid: this.companyUser.company_uuid,
        project_uuid: null,
        name: null,
        mb_feature_polygon: null,
        lat: null,
        lng: null,
      },
    }
  },
  props: {
    initialSite: { type: Object },
    zones: { type: Array, default: () => [] },
  },
  components: {
    Button,
    Form,
    FormInput,
    ImageUpload,
    ProjectSelect,
    SiteDrawHelp,
    BaseMap,
  },
  methods: {
    handleCoordinatesUpdate(newCoordinates) {
      const center = mapUtils.calculateCenterOfCoordinates(mapUtils.coordinatePairArrayToLngLatObject(newCoordinates))
      this.site.mb_feature_polygon = JSON.stringify({
        type: 'FeatureCollection',
        features: [
          {
            id: this.site.uuid,
            type: 'Feature',
            properties: {},
            geometry: {
              coordinates: [newCoordinates],
              type: 'Polygon',
            },
          },
        ],
      })

      this.site.lat = center.lat
      this.site.lng = center.lng
    },
    resetCoordinates() {
      this.site.lat = null
      this.site.lng = null
    },
  },
  computed: {
    isNew() {
      return !this.site.uuid
    },
    submitDisabled() {
      const { name, mb_feature_polygon, lat, lng, project_uuid } = this.site
      return !name || !mb_feature_polygon || !lat || !lng || !project_uuid
    },
    staticPolygonsForMap() {
      return [...this.areaPolygons, ...this.zonePolygons].filter(polygon => polygon)
    },
    zonePolygons() {
      return this.zones?.map(zone => staticPolygonsFromObject('zone', zone)) || []
    },
    areaPolygons() {
      return this.site?.areas?.map(area => staticPolygonsFromObject('area', area)) || []
    },
    geojsonFeature() {
      if (this.isNew) return null
      return JSON.parse(this.site.mb_feature_polygon).features[0]
    },
    siteBounds() {
      if (this.isNew) return null
      return staticPolygonsFromObject('site', this.site).properties.bbox
    },
  },
}
</script>
